import React, { useEffect, useRef, useState } from "react";
import { Icon, DefaultButton, TooltipHost, Spinner, Callout, DirectionalHint } from "@fluentui/react";
import "./cargaPorTabla.css";
import { IAddRows, IComboBoxOptionGrid, IComboBoxProject, IMyDetailsList, ItipoConceptoGrid } from "./InterfaceTabla";
import { t } from "i18next";
import "@glideapps/glide-data-grid/dist/index.css";
import DataEditor, { GridCellKind, Item, GridCell, GridColumn, DataEditorRef, GridMouseEventArgs, BubbleCell, GridSelection, CompactSelection, SpriteMap, DrawHeaderCallback } from "@glideapps/glide-data-grid"
import { DropdownCell, DropdownRenderer } from "../../lib/GlideDataGrid/ComboxGlideGrid";
import { IBounds, useLayer } from "react-laag";
import { IAEnhanceButtonCell, IAEnhanceButtonRenderer } from "../../lib/GlideDataGrid/ButtomIaGlideGrid";
import { ValidaCell, ValidaCellRenderer } from "../../lib/GlideDataGrid/ValidaGlideGrid";
import { AdjuntoCell, AdjuntoCellRenderer } from "../../lib/GlideDataGrid/AdjuntoGlideGrid";
import { DropdownMultiSelectCell, DropdownMultiSelectRenderer } from "../../lib/GlideDataGrid/MultiSelectGrid";
import { handleColumnResizeUtil, processPastedValues } from "../../lib/GlideDataGrid/UtilsGlideGrid";
import { useActivityEnhancement } from "../../common/custom-hooks/useActivityEnhancement";
import { TypeMessageEnhancement } from "../../common/custom-hooks/useProjectEnhancement";
import { ButtonCell, ButtonCellRenderer } from "../../lib/GlideDataGrid/ButtomGlideGrid";
import { TextCell, TextCellRenderer } from "../../lib/GlideDataGrid/TextGlidGrid";

export interface IListFile {
 id: string;
 file:Ifileselect;
 path:File
}

export interface Ifileselect {
    cmd_proid: string | number;
    cmd_cant_archivos: number;
    cmd_cant_bytes_total: number;
    cmd_tipo: string;
    cargaDocumentosItems:Idocumentos[];
    folderId: string;
}

interface Idocumentos{
    cmdi_cant_bytes: number;
    cmdi_doc_uuid: string;
    cmdi_nombre_archivo: string;
    cmdi_content_type: string;
    doctId: string;
    tipo: string;
}

interface FileUploadProps {
  onFileSelect: (file: File) => void;
  disabled:boolean;
}

export interface IDocumento {
  cmd_proid: string | null;
  cmd_cant_archivos: number | null;
  cmd_cant_bytes_total: number | null;
  cmd_tipo: string | null;
  cmd_estado: string | null;
  cmd_fecha_inicio: string | null;
  cmd_id: string | null;
  cmd_carga_colid: string | null;
  cmd_owner_colid: string | null;
  cmd_actid: string | null;
  cmd_liqid: string | null;
  colaborador: Colaborador | null;
  proyecto: Proyecto | null;
  cargaDocumentosItems: CargaDocumentoItem[];
}

interface CargaDocumentoItem {
  cargaDocumentos: any | null;
  documentoXActividad: any | null;
  cmdi_id: string;
  cmdi_cmdid: string;
  cmdi_aws_bucket: string;
  cmdi_aws_key: string;
  cmdi_cant_bytes: number;
  cmdi_codigo_error: string;
  cmdi_content_type: string;
  cmdi_doc_uuid: string;
  cmdi_doctid: string;
  cmdi_dxaid: any | null;
  cmdi_dxliid: any | null;
  cmdi_estado: string;
  cmdi_fecha_aws_fin: any | null;
  cmdi_fecha_fin: any | null;
  cmdi_fecha_ultimo_progreso: any | null;
  cmdi_mensaje_error: string;
  cmdi_nombre_archivo: string;
  cmdi_pcaid: string;
  cmdi_ruta_local: string;
}

interface Colaborador {}

interface Proyecto {}

interface IconPapersProps {
    nameIcon: string;
    size?: string;
    color?: string;
    thickness?: number;
    onClick?: () => void;
}

export interface Iactivities {
  impai_nombre: string;
  impai_cantidad_horas: string;
  impai_codigo_proyecto: string | undefined;
  impai_proid: string | number;
  impai_con_error: boolean;
  impai_descripcion_error: string;
  impai_descripcion: string;
  impai_empresas: any[];
}

const formatDate = (dateString:Date) => {
  const date = new Date(dateString);
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${year}-${month}`;
}

const convertMinToHour = (minutes: number): string => {

  const hours = Math.trunc(minutes/ 60);
  const remaining = Math.round(Math.abs(minutes - hours * 60));

  return `${hours}:${String(remaining).padStart(2, '0')}`;
};

const convertHourToMin = (hoursCarg: string,  minutesCarg: string = "00"): number => {

  const hourMin =  `${hoursCarg}:${minutesCarg}` || "00:00";
  const [hoursStr, minutesStr] = hourMin.split(':');
  const hours = hoursStr ? parseInt(hoursStr, 10) : 0;
  const minutes = minutesStr === 'undefined' ? 0 : (minutesStr ? parseInt(minutesStr, 10) : 0);

  return hours * 60 + minutes;
};

const FileUpload: React.FC<FileUploadProps> = ({ onFileSelect, disabled = true }) => {
  const [selectedFileName, setSelectedFileName] = useState<string | null>(null);
  const [clicked, setClicked] = useState(false);
  const fileInputRef = React.createRef<HTMLInputElement>();

  const handleClick = () => {
    setClicked(true);
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files[0]) {
      const file = files[0];
      setSelectedFileName(file.name);
      onFileSelect(file);
    }
  };

  return (
    <DefaultButton 
      onClick={handleClick} 
      disabled={disabled} 
      style={{ border: "none" }} 
      styles={{
        root: {
          border: "none",
          background: "transparent", 
        },
        rootDisabled: {
          background: "transparent", 
        },
        rootHovered: {
          background: "transparent" 
        },
        rootPressed: {
          background: "transparent", 
        },
      }}
    >
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <TooltipHost content={t(selectedFileName || "Seleccione un archivo")}>
        <Icon
          iconName="CloudUpload"
          style={{
            fontSize: "30px",
            cursor: disabled ? "default" : "pointer",
            color: selectedFileName ? "#0078D4" : (disabled ? "#9E9E9E" : "black"),
          }}
          className={(clicked && selectedFileName) ? "icon-clicked" : ""}
          onAnimationEnd={() => setClicked(false)}
        />
      </TooltipHost>
    </DefaultButton>
  );
};

const IconPapers: React.FC<IconPapersProps> = ({
    nameIcon,
    size = "16px", // default size
    color = "black", // default color
    thickness = 1, // default thickness
    onClick,
  }) => {
    const styles = {
      fontSize: size,
      color: color,
      fontWeight: thickness * 100,
      cursor: onClick ? "pointer" : "default",
    };
  
    return <Icon iconName={nameIcon} style={styles} onClick={onClick} />;
  };

  const LoadingPage = ()=>{
    return (
      <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: 10,
        paddingTop:"10px"
      }}
    >
      <Spinner label={t("Cargando...")} />
    </div>
    );
  }

  const zeroBounds: IBounds = {
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    right: 0,
    bottom: 0,
  };

  const MyDetailsList = ({
    addRows,
    listCompanies,
    filterTipoConsept,
    onselectCountry,
    countryFilterChange,
    onselectCompany,
    companyFilterChange,
    onselecTipoConcept,
    tipoConceptFilterChange,
    onselectProject,
    ProjectFilterChange,
    HandlerNombreAct,
    HandlerNombreActNuevo,
    handlerDescripcion,
    HandlerContHoras,
    handlerDuplicateRow,
    HandlerDeleteRows,
    loading,
    onClickCallout,
    aiActivityEnhancementSystem,
    updateActivityNameAndDescription,
    handleMultipleFiles,
    handleFileDelete,
    HandlerAddRows,
    HandlerContOnlyMinute,
    HandlerPasteData,
    HandlerDeleteData,
    handleSelectedRowsChange,
    countAddRows,
    selectedRowsMain
  }:IMyDetailsList) => {

    const [aiGeneratedFocus, setAIGeneratedFocus] = useState<{ [rowId: string]: boolean }>({});
    const [selectedRows, setSelectedRows] = useState<IAddRows[]>([]);
    const [gridSelection, setGridSelection] = useState<GridSelection | undefined>(undefined);
    const [allSelected, setAllSelected] = useState(false);

    const ref = useRef<DataEditorRef>(null);
    const [columns, setColumns] = React.useState<GridColumn[]>([
      { id: "__select__",
        title: "",
        width: 32,
        icon: "unchecked",
        group: "",
        themeOverride:{
          bgHeader: "transparent",
        }
      },
      {
        id: "nombreEmp",
        title: t("Empresa (*)"),
        width: 350,
        group: t("Informacion General"),
      },
      {
        id: "tipoConcepto",
        title: t("Concepto (*)"),
        width: 250,
        group: t("Informacion General"),
      },
      {
        id: "nombrePro",
        title: t("Proyecto/Servicio (*)"),
        width: 300,
        group: t("Informacion General"),
      },
      {
        id: "nombreAct",
        title: t("Actividad (*)"),
        width: 250,
        group: t("Informacion General"),
      },
      {
        id: "descripcion",
        title: t("Descripción"),
        width: 250,
        group: t("Informacion General"),
      },
      {
        id: "horasCarg",
        title: t("Horas (*)"),
        width: 140,
        group: t("Tiempo total a cargar"),
      },
      {
        id: "minuteCarg",
        title: t("Minutos (*)"),
        width: 140,
        group: t("Tiempo total a cargar"),
      },
      {
        id: "ia",
        title: t("Mejorar con IA"),
        width: 140,
        group: t("Acciones en la tabla"),
      },
      {
        id: "valida",
        title: t("Valida"),
        width: 100,
        group: t("Acciones en la tabla"),
      },
      {
        id: "descripcionError",
        title: t("Descripción del error"),
        width: 300,
        group: t("Acciones en la tabla"),
      },
      {
        id: "adjunto",
        title: t("Adjunto"),
        width: 100,
        group: t("Acciones en la tabla"),
      },
    ]);
    const minutoOptions: IComboBoxOptionGrid[] = [
      { value: "00", label: "00" },
      { value: "15", label: "15" },
      { value: "30", label: "30" },
      { value: "45", label: "45" },
    ];

    const getCellContent = ([col, row]: Item): GridCell => {

      const item = addRows[row] || {};
      const [hour, minute] = (item.horasCarg || '00:00')
        .split(':')
        .map(part => part === 'undefined' || part === undefined ? '00' : part);

      switch (col) {
        case 0:
          const isSelected = selectedRows.some((r) => r.id === item.id);
          return {
            kind: GridCellKind.Boolean,
            data: isSelected,
            allowOverlay: false,
            readonly: true
          };
        case 1:
          return {
            kind: GridCellKind.Custom,
            allowOverlay: true,
            copyData:
              item.comapaniesSelect?.map((v) => v.label).join(", ") || "",
            cursor: "pointer",
            data: {
              kind: "dropdown-multiselect-cell",
              value: item.comapaniesSelect,
              displayData:
                item.comapaniesSelect?.map((v) => v.label).join(", ") || "",
              options: listCompanies as IComboBoxOptionGrid[],
              placeholder: t("Empresa"),
              id: item.id,
              width: "150px",
              onChange: onselectCompany,
            },
          } as DropdownMultiSelectCell;
        case 2:
          return {
            kind: GridCellKind.Custom,
            allowOverlay: true,
            copyData: item.tipoConcepto?.text || "",
            cursor: "pointer",
            data: {
              kind: "dropdown-cell",
              value: {
                value: item.tipoConcepto?.key,
                label: item.tipoConcepto?.text,
              },
              displayData: item.tipoConcepto?.text || "",
              options: filterTipoConsept as ItipoConceptoGrid[],
              placeholder: t("Indique el concepto"),
              id: item.id,
              width: "150px",
              alignContent: "left",
              onChange: onselecTipoConcept,
            },
          } as DropdownCell;
        case 3:
          const projectFound = item.listaProyectos.find((project) => project.value === item.nombrePro.key);
          return {
            kind: GridCellKind.Custom,
            allowOverlay: true,
            copyData: item.nombrePro?.text || "",
            cursor: "pointer",
            data: {
              kind: "dropdown-cell",
              value: {
                value: projectFound?.value, // item.nombrePro.key
                label: projectFound?.label, //item.nombrePro.text
              },
              displayData: item.nombrePro?.text ?? "",
              options: item.listaProyectos as IComboBoxOptionGrid[],
              placeholder: t("Indique el proyecto/servicio"),
              disabled: !item?.tipoConcepto?.key,
              id: item.id,
              width: "150px",
              alignContent: "left",
              onChange: onselectProject,
            },
          } as DropdownCell;
        case 4:
          return {
            kind: GridCellKind.Custom,
            allowOverlay: true,
            copyData: item?.nombreAct || "",
            cursor: "pointer",
            data: {
              kind: "dropdown-cell",
              value: {
                value: item.nombreAct,
                label: item.nombreAct,
              },
              displayData: item?.nombreAct ?? "",
              options: item.lisActRecurrente,
              disabled: !item?.nombrePro?.key,
              placeholder: t("Indique el titulo de la actividad"),
              id: item.id,
              width: "150px",
              alignContent: "left",
              className: aiGeneratedFocus[item.id]
                ? "input-focus-ai-generate"
                : "",
              onChange: HandlerNombreAct,
              isEditableInputText:true
            },
          } as DropdownCell;
        case 5:
          return {
            allowOverlay: true,
            kind: GridCellKind.Custom,
            copyData: item.descripcion || "",
            data: {
              id: item.id,
              kind: "text-cell",
              value: item.descripcion,
              placeholder: t("Escriba una Descripción"),
              disabled: false,
              onChange: handlerDescripcion,
              className: aiGeneratedFocus[item.id]
                ? "input-focus-ai-generate"
                : "",
            },
            themeOverride: aiGeneratedFocus[item.id]
              ? { bgCell: "#F8FFEB", textDark: "#1E7D01" }
              : undefined,
          } as TextCell;
        case 6:
          return {
            allowOverlay: true,
            kind: GridCellKind.Text,
            cursor: "pointer",
            data: item.horasCarg.split(":")[0],
            contentAlign: "center",
            displayData: hour || "00",
            copyData: hour
          };
        case 7:
          return {
            allowOverlay: true,
            kind: GridCellKind.Custom,
            cursor: "pointer",
            copyData: item.minuteCarg || "00",
            data: {
              kind: "dropdown-cell",
              value: {
                value: item.minuteCarg || "00",
                label: item.minuteCarg || "00",
              },
              displayData: item.minuteCarg || "00",
              options: minutoOptions,
              placeholder: "mm",
              id: item.id,
              width: "150px",
              alignContent: "center",
              onChange: HandlerContOnlyMinute,
            },
          } as DropdownCell;
        case 8:
          return {
            kind: GridCellKind.Custom,
            allowOverlay: true,
            copyData: "",
            readonly: true,
            data: {
              kind: "button-cell",
              label: "✨ " + t("Mejorar"),
              value: item,
              onClick: handleIaGeneration,
              disabled: !item?.nombreAct || !item?.nombrePro,
            },
          } as ButtonCell;
        case 9:
          return {
            kind: GridCellKind.Custom,
            allowOverlay: false,
            copyData: "",
            readonly: true,
            data: {
              kind: "valida-cell",
              id: item.id,
              valida: item.valida,
              descripcionError: item.descripcionError,
            },
          } as ValidaCell;
        case 10:
          return {
            kind: GridCellKind.Text,
            copyData: "",
            data: "",
            displayData: item.descripcionError,
            allowOverlay: false,
            readonly: true,
            themeOverride: { textDark: "red" },
          };
        case 11:
          return {
            kind: GridCellKind.Custom,
            allowOverlay: true,
            copyData: "",
            cursor: "pointer",
            readonly: true,
            data: {
              kind: "adjunto-cell",
              id: item.id,
              nombrePro: item.nombrePro,
              files: item.files || [],
              onMultipleFiles: handleMultipleFiles,
              onFileDelete: handleFileDelete,
            },
          } as AdjuntoCell;
        default:
          return {
            kind: GridCellKind.Text,
            data: "",
            displayData: "",
            allowOverlay: false,
          };
      }
    };

    // inicio tooltip
    const [tooltip, setTooltip] = React.useState<{ val: IAddRows; bounds: IBounds } | undefined>();
    const timeoutRef = React.useRef(0);

    // const onItemHovered = React.useCallback((args: GridMouseEventArgs) => {
    //   if (args.kind === "cell") {
    //     window.clearTimeout(timeoutRef.current);
    //     setTooltip(undefined);

    //     timeoutRef.current = window.setTimeout(() => {
    //       const [col, row] = args.location;
    //       const cell = getCellContent([col, row]);
    //       const colDef = columns[col];

    //       console.log("onItemHovered-colDef", colDef.id);

    //       let val = "";

    //       if (cell.kind === GridCellKind.Text) {
    //         val = cell.displayData ?? cell.data ?? "";
    //       } else if (cell.kind === GridCellKind.Custom) {
    //         const data: any = cell.data;
    //         val = data?.value ?? "";

    //         if (colDef.id === "nombrePro" && data.value) {
    //           val = `${data.value} \ninicia el ${data.object.pro_inicio.toFormat("dd/LL/yyyy")} y termina el ${data.object.pro_fin.toFormat("dd/LL/yyyy")}`;
    //         }

    //         if (colDef.id === "valida") {
    //           val = data?.descripcionError ?? "";
    //         }

    //         if (colDef.id === "horasCarg") {
    //           val = "";
    //         }
    //       }

    //       if (val) {
    //         setTooltip({
    //           val,
    //           bounds: {
    //             left: args.bounds.x,
    //             top: args.bounds.y,
    //             width: args.bounds.width,
    //             height: args.bounds.height,
    //             right: args.bounds.x + args.bounds.width,
    //             bottom: args.bounds.y + args.bounds.height,
    //           },
    //         });
    //       } else {
    //         setTooltip(undefined);
    //       }
    //     }, 500);
    //   } else {
    //     window.clearTimeout(timeoutRef.current);
    //     timeoutRef.current = 0;
    //     setTooltip(undefined);
    //   }
    // }, [columns, getCellContent]);

    React.useEffect(() => () => window.clearTimeout(timeoutRef.current), []);

    const isOpen = tooltip !== undefined;
    const { renderLayer, layerProps } = useLayer({
      isOpen,
      triggerOffset: 4,
      auto: true,
      container: "portal",
      trigger: {
        getBounds: () => tooltip?.bounds ?? zeroBounds,
      },
    });

    //fin tooltip

    const handleColumnResize = React.useCallback(
      handleColumnResizeUtil(setColumns),
      [setColumns]
    );

    const handleCellEdited = (
      cell: readonly [number, number],
      newValue: any
    ) => {
      const [col, row] = cell;
      const colDef = columns[col];
      const rowData = addRows[row];

      switch (colDef.id) {

        case "horasCarg":
          HandlerContHoras(rowData.id, newValue.data, "hour");
          break;

        case "minuteCarg":
          HandlerContHoras(rowData.id, newValue.data, "minute");
          break;

        default:
          break;
      }
    };

    const activityEnhancement = useActivityEnhancement(
      aiActivityEnhancementSystem
    );

    const handleIaGeneration = (item) => {
      const activity_name = item.nombreAct;
      const project_name = item.nombrePro.text;
      const activity_description = item.descripcion;
      const company_country = item.paisEmpresa.text;
      const company_name = item.nombreEmp.text;
      const project_code = item.nombrePro.code || "";

      if (!activity_name.trim() || !project_name.trim())
        return activityEnhancement.showMessage({
          type: TypeMessageEnhancement.WARNING,
          className: "warning-message-animate",
          value:
            "⚠️ El nombre de la actividad y nombre del proyecto es requerido",
        });
      activityEnhancement.generateEnhancement(
        {
          activity_name,
          project_name,
          activity_description,
          company_country,
          company_name,
          project_code,
        },
        (result) => {
          updateActivityNameAndDescription(
            item.id,
            result.activity_name,
            result.activity_description
          );
          setAIGeneratedFocus((prev) => ({
            ...prev,
            [item.id]: true,
          }));
        }
      );
    };

    const headerIcons = React.useMemo<SpriteMap>(
      () => ({
        check: (p) => `
        <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="4" width="32" height="32" rx="6" stroke="#c6c6c6" stroke-width="3"/>
          <path d="M10 20l7 7 14-14" stroke="#c6c6c6" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `,
        unchecked: (p) => `
        <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="2" width="16" height="16" rx="3" stroke="#c6c6c6" stroke-width="1"/>
        </svg>
      `,
      }),
      []
    );

    useEffect(() => {
      if (selectedRowsMain.length === 0) {
        setGridSelection(undefined);
      }
    }, [selectedRowsMain]);

    useEffect(() => {
      if (selectedRows.length > 0) {
        const idSelectRows = selectedRows.map(r => r.id);
        const updateSelectedRows = addRows.filter((row) => row.id && idSelectRows.includes(row.id));
        handleSelectedRowsChange(updateSelectedRows);
      }
    }, [addRows]);

    return (
      <div style={{ position: "relative" }}>
        {loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10,
            }}
          >
            <Spinner label={t("Cargando datos...")} />
          </div>
        )}
        <div>
          <DataEditor
            ref={ref}
            customRenderers={[
              DropdownRenderer,
              IAEnhanceButtonRenderer,
              ValidaCellRenderer,
              AdjuntoCellRenderer,
              DropdownMultiSelectRenderer,
              ButtonCellRenderer,
              TextCellRenderer,
            ]}
            getCellContent={getCellContent}
            columns={columns}
            rows={addRows.length}
            smoothScrollX
            smoothScrollY
            rowSelect="multi"
            columnSelect="multi"
            onCellEdited={handleCellEdited}
            onDelete={(selection) => {
              const deletedData: any[][] = [];
              const noDeleteData: string[] = ["ia", "valida", "adjunto"];

              const buildRowClearPayload = (
                rowIndex: number,
                colIndexes?: number[]
              ) => {
                const rowId = addRows[rowIndex]?.id;

                if (rowId == null) return;

                const rowPayload: any[] = [{ id: rowId }];

                if (Array.isArray(colIndexes) && colIndexes.length > 0) {
                  colIndexes.forEach((ci) => {
                    const colDef = columns[ci];
                    if (!colDef?.id) return;

                    if (noDeleteData.includes(colDef.id)) return;
                    rowPayload.push({ [colDef.id]: "" });
                  });
                }

                deletedData.push(rowPayload);
              };

              try {
                const anySel: any = selection as any;

                // 1) Rango actual de celdas seleccionadas (si existe)
                const range = anySel?.current?.range;

                if (
                  range &&
                  Number.isInteger(range.x) &&
                  Number.isInteger(range.y)
                ) {
                  const startCol = Math.max(0, range.x);
                  const endCol = Math.min(
                    columns.length - 1,
                    range.x + (range.width ?? 1) - 1
                  );
                  const startRow = Math.max(0, range.y);

                  const endRow = Math.min(
                    addRows.length - 1,
                    range.y + (range.height ?? 1) - 1
                  );

                  const colIndexes: number[] = [];
                  for (let c = startCol; c <= endCol; c++) colIndexes.push(c);
                  for (let r = startRow; r <= endRow; r++)
                    buildRowClearPayload(r, colIndexes);
                }

                // 2) Filas completas seleccionadas
                const rowsSel = anySel?.rows;
                let selectedRowIndexes: number[] = [];
                if (Array.isArray(rowsSel)) {
                  selectedRowIndexes = rowsSel;
                } else if (rowsSel && typeof rowsSel.toArray === "function") {
                  selectedRowIndexes = rowsSel.toArray();
                }
                if (selectedRowIndexes.length > 0) {
                  selectedRowIndexes.forEach((r) => buildRowClearPayload(r));
                }

                // 3) Columnas completas seleccionadas (aplicar a todas las filas actuales)
                const colsSel = anySel?.columns;
                let selectedColIndexes: number[] = [];
                if (Array.isArray(colsSel)) {
                  selectedColIndexes = colsSel;
                } else if (colsSel && typeof colsSel.toArray === "function") {
                  selectedColIndexes = colsSel.toArray();
                }
                if (selectedColIndexes.length > 0) {
                  for (let r = 0; r < addRows.length; r++)
                    buildRowClearPayload(r, selectedColIndexes);
                }

                if (deletedData.length > 0) {
                  HandlerDeleteData(deletedData);
                }
              } catch (e) {
                console.warn("onDelete selection processing failed:", e);
              }

              return false;
            }}
            keybindings={{
              selectAll: true,
              copy: true,
              paste: true,
              delete: true,
            }}
            onPaste={(target, values) => {
              (async () => {
                try {
                  const textClipboardFromExcel =
                    await navigator.clipboard.readText();

                  const parsedValuesCopyExcel = textClipboardFromExcel
                    /* .trim() */
                    .split(/\r?\n/)
                    .map((row) =>
                      row.split(/\t/).map((cell) =>
                        cell
                          .replace(/[\n\r]+/g, " ")
                          .replace(/[^\S\r\n]+/g, " ")
                          .trim()
                      )
                    );

                  const pastedData = processPastedValues(
                    target,
                    parsedValuesCopyExcel,
                    getCellContent,
                    columns,
                    addRows
                  );

                  console.log({ target, values, textClipboardFromExcel, parsedValuesCopyExcel, pastedData, columns, addRows});
                  
                  HandlerPasteData(pastedData);
                } catch (err) {
                  console.error("Error leyendo el portapapeles:", err);
                }
              })();

              return false;
            }}
            getCellsForSelection={true}
            gridSelection={gridSelection}
            onGridSelectionChange={setGridSelection}
            headerIcons={headerIcons}
            onHeaderClicked={(col) => {
              if (columns[col].id === "__select__") {
                const newValue = !allSelected;
                setAllSelected(newValue);

                setColumns((prev) =>
                  prev.map((c, i) =>
                    i === 0
                      ? {
                          ...c,
                          icon: newValue ? "check" : "unchecked",
                          themeOverride: {
                            bgHeader:
                              c.themeOverride?.bgHeader != null ? "transparent" : "transparent"
                          },
                        }
                      : c
                  )
                );

                if (newValue) {
                  setSelectedRows(addRows);
                  handleSelectedRowsChange(addRows);
                } else {
                  setSelectedRows([]);
                  handleSelectedRowsChange([]);
                }
              }
            }}
            onCellClicked={(cell, event) => {
              const [col, row] = cell;
              const colDef = columns[col];
              const rowData = addRows[row];

              if (col === 0) {
                setSelectedRows((prevSelected) => {
                  const alreadySelected = prevSelected.some(
                    (r) => r.id === rowData.id
                  );

                  let newSelected: typeof prevSelected;

                  if (alreadySelected) {
                    newSelected = prevSelected.filter(
                      (r) => r.id !== rowData.id
                    );
                  } else {
                    newSelected = [...selectedRowsMain, rowData];
                  }
                  handleSelectedRowsChange(newSelected);
                  return newSelected;
                });

                return;
              }
            }}
            onColumnResize={handleColumnResize}
            trailingRowOptions={{
              hint: `Agregar fila ${countAddRows}`,
              sticky: true,
              tint: true,
            }}
            onRowAppended={() => {
              HandlerAddRows(countAddRows);
            }}
            width={"100%"}
          />
        </div>
      </div>
    );
  };

export { FileUpload, IconPapers ,formatDate,convertMinToHour,convertHourToMin,LoadingPage,MyDetailsList };